/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Descriptor, { IDescriptorBody } from './../../descriptor';

interface ICommonComment {
	commentId: string;
	commentThreadId: string;
	userId: string;
	content: string;
	documentId: string;
}

export interface ICommentJSON extends ICommonComment {
	createdAt: string;
	attributes: string | null;
}

export interface IComment extends ICommonComment {
	createdAt: Date;
	attributes: Record<string, unknown> | null;
}

export default class CommentDescriptor extends Descriptor {
	public static readonly DESCRIPTOR_NAME: string = 'CommentDescriptor';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentId: {
				id: 1,
				type: 'string'
			},
			commentThreadId: {
				id: 2,
				type: 'string'
			},
			userId: {
				id: 3,
				type: 'string'
			},
			content: {
				id: 4,
				type: 'string'
			},
			documentId: {
				id: 5,
				type: 'string'
			},
			createdAt: {
				id: 6,
				type: 'string'
			},
			attributes: {
				id: 7,
				type: 'string'
			}
		}
	};

	public static toJSON( comment: IComment ): ICommentJSON {
		return {
			...comment,
			createdAt: comment.createdAt?.toISOString(),
			attributes: comment.attributes ? JSON.stringify( comment.attributes ) : null
		};
	}

	public static fromJSON( comment: ICommentJSON ): IComment {
		return {
			...comment,
			createdAt: new Date( comment.createdAt ),
			attributes: comment.attributes ? JSON.parse( comment.attributes ) : null
		};
	}
}
